module.exports = __webpack_public_path__ + "img/qrcode.4f0d8453.png";